// CHECK IF THE USER HAS THE REQUIRED PERMISSION
// - The userProfile must be an object with roles and groups arrays
// - The organization is the currently selected organization
// - The resource must be a string (i.e. "ARCHIVIOSTORICO", "BIBLIOGRAFIA", "CASSETTA", "COMUNE", "LAYER",  "MOVIMENTAZIONE", "REPERTO", "ROLE" o "USER")
// - The resourceGroups must be an array of objects with a name property (the groups associated to the resource)
// - The permission must be a string (i.e. "CREATE", "WRITE", "DELETE", or "READ"). NOTE: the user that can write can also create.

// THE ADMIN user can READ/CREATE/WRITE/DELETE ANY RESOURCE in ITS ORGANIZATION (ROLES ARE EXCLUDED
// ADMINS WITH ORGANIZATION NULL CAN READ/CREATE/WRITE/DELETE ANY RESOURCE
// Other users need the required READ/WRITE/DELETE authority withing their own ORGANIZATION
// for CASSETTA and REPERTO they need alto to be part of at least one of the groups associated to the resource

const userHasPermission = ({userProfile, organization, resource, resourceGroups, permission}) => {
  if( !userProfile     
    || !Array.isArray(userProfile.roles)
    || typeof organization !== 'object'
    || !Array.isArray(userProfile.groups)
    || typeof resource !== 'string' 
    || typeof permission !== 'string' 
    || !["create", "write", "delete", "read"].includes(permission.toLowerCase())) return false;

  // RELEVANT ROLES AND GROUPS SHOULD BE FILTERED BY THE USER ORGANIZATION

  const relevantRoles = userProfile.roles.filter ((r)  =>  organization?.id === null ? r.organization === null : r.organization?.id === organization?.id);
  const relevantGroups = userProfile.groups.filter ((g)  =>  organization?.id === null ? g.organization === null : g.organization?.id === organization?.id);

  // ADMIN IS ALWAYS ALLOWED IN ITS ORGANIZATION READING, WRITING OR DELETING 
  // ROLES AMD ORGANIZATIONS are EXCLUDED UNLESS ORGANIZATION IS NULL)

  if(relevantRoles.some((r) => r.authorities.some((aut) => aut === "ADMIN"))) {
    if (['role','organization'].includes(resource.toLowerCase()) 
        && organization?.id !== null) return false;
    else return true; 
  };

  // USER SHOULD HAVE THE REQUIRED PERMISSION
  // Handle CREATE permission - users who can WRITE can also CREATE
  const requiredPermission = permission.toLowerCase() === "create" ? "write" : permission.toLowerCase();
  
  if (!relevantRoles.some((r) =>
    r.authorities.some((aut) => aut.toLowerCase() === `${resource.toLowerCase()}_${requiredPermission}`
  ))) return false;

  // USERS CAN'T EDIT OR DELETE A CASSETTA OR REPERTO IF THEY ARE NOT PART OF THE RESOURCE GROUPS
  if ( ["write", "delete"].includes(permission.toLowerCase()) && (resource.toLowerCase() === "cassetta" || resource.toLowerCase() === "reperto")) {
    // Check if user has any groups in the current organization
    if(!relevantGroups.length) return false;
    
    // IF THERE ARE RESOURCE GROUPS, THE USER SHOULD BE PART OF AT LEAST ONE OF THEM
    if(resourceGroups?.length > 0 && !relevantGroups.some((g) => resourceGroups?.some((d) => d.id === g.id))) return false;
  }

  // USERS CAN'T CREATE A CASSETTA OR REPERTO IF THEY ARE NOT PART AT LEAST OF A GROUP
  if ( "create" === permission.toLowerCase() && (resource.toLowerCase() === "cassetta" || resource.toLowerCase() === "reperto")) {
    if (relevantGroups.length === 0) return false;
  }


  return true;
};

export default userHasPermission;


